import React, { useState } from 'react'
import { CloseIcon, FilterBlack, FilterIcon, filterBlackIcon } from '../../../../assets/images'
import { ButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import RadioContainer from '../../Radio/RadioContainer'
import { RadioTypes } from '../../../../commonTypes/universalTypes'
import { STATES_LIST_WITH_CODE } from '../../../../constant/stateListConstants'
import Select from "react-select";
import { FilterType } from '../../../../commonTypes/gstTypes'
import { EXPORT_OPTION, SALES_TYPE_OPTION, SEZ_OPTION, SEZ_TAX_PAYMENT_OPTION } from '../../../../constant/tableHeadersConstants/gst'

type AppProps={
    type:string;
    multiSelectData:any;
    filters:FilterType;
    setFilters:(data:any)=>void;
    filtersValue:FilterType,
    setFiltersValue:(data:any)=>void;
    setMultiSelectData:(data:any)=>void;
    setOffset:(data:number)=>void;
    resetData:()=>void;
}


const OutWardsFilter = (
    {filtersValue,
    setFiltersValue,
    filters,
    multiSelectData,
    setFilters,
    type,
    setMultiSelectData,
    setOffset,
    resetData
}:AppProps) => {

    const [toggle, setToggle] = useState<boolean>(false);

    const handleSubmit=()=>{
        setOffset(0)
        resetData()
      setFilters({...filtersValue});
    }

    const onChange=(item:any,name:string): void=>{
        setFiltersValue((prev:any)=>({...prev,[name]:item}))
    }

    const clearFilter=()=>{
        setOffset(0)
        resetData()
        setFilters({sez:"",placeOfSupply:{label:"Select State",value:""},sezTaxPayment:"",exports:"",salesType:""})
        setFiltersValue({sez:"",placeOfSupply:{label:"Select State",value:""},sezTaxPayment:"",exports:"",salesType:""})
        setMultiSelectData([])
    }

    const resetFilterData=()=>{
  
            setFiltersValue((prev:any)=>({...prev,exports:filters?.exports}))
   
            setFiltersValue((prev:any)=>({...prev,sez:filters?.sez}))
   
            setFiltersValue((prev:any)=>({...prev,sezTaxPayment:filters?.sezTaxPayment}))
    
            setFiltersValue((prev:any)=>({...prev,salesType:filters?.salesType}))
    
            let selectedState:any=STATES_LIST_WITH_CODE?.filter((item:any)=>item?.value==filters?.placeOfSupply?.value)
            setFiltersValue((prev:any)=>({...prev,placeOfSupply:selectedState?.length>0 ?selectedState[0] : {label:"Select State",value:""}}))
     
    }

    return (
        <ButtonDropdown
            isOpen={toggle}
            toggle={() => {
                resetFilterData()
                setToggle(!toggle)
            }}
        >
            <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 250 }}
                overlay={<Tooltip id="button-view-filter-invoice">
                    Filter
                </Tooltip>}>

                <DropdownToggle
                    caret
                    color="secondary"
                    style={toggle ? {
                        color: "#dd4433",
                        border: "1px solid #dd4433",
                        backgroundColor: "#fff6f5"
                    } : { border: "1px solid#bfcbe1" }}
                    outline

                >
                    <img src={toggle ? FilterIcon : filterBlackIcon} alt="" /> <span className={multiSelectData?.length>0 ? 'filter-count':""}><span>{multiSelectData?.length>0 ? multiSelectData?.length : null}</span></span>
                </DropdownToggle>
            </OverlayTrigger>

            <DropdownMenu right>
                <div className="download-dropdown p-3">

                    <div className='d-flex justify-content-between align-items-center mt-0 mb-0'>
                        <h5 className='text-center '>Filter</h5>
                        <div className='pointer' onClick={() => {
                            setToggle(!toggle)
                            // setClearFilter(false)
                        }}>
                            <img src={CloseIcon} alt="" />
                        </div>

                    </div>
                    <hr className='mt-0 mb-0' />

                    <div className='mt-2 ml-1'>
                        <div>
                            <label className='mb-1'>Place Of Supply</label>
                            <Select
                                className="dropdown"
                                placeholder={"Search State"}
                                value={filtersValue?.placeOfSupply}
                                options={STATES_LIST_WITH_CODE}
                                onChange={(item:any)=>onChange(item,"placeOfSupply")}
                                isSearchable={true}
                            />
                        </div>
                    </div>

                    <div className='mt-2 ml-1'>
                        <label className='mb-1'>Sales Type</label>
                        <div>
                            <RadioContainer
                                optionsList={SALES_TYPE_OPTION}
                                handleSetRadioValue={(item:string)=>onChange(item,"salesType")}
                                radioValue={filtersValue?.salesType}
                                alignment="horizontal"
                                backGround={true}
                            />
                        </div>
                    </div>
                    <div className='mt-2 ml-1'>
                        <label className='mb-1'>SEZ Payment</label>
                        <div>
                            <RadioContainer
                                optionsList={SEZ_TAX_PAYMENT_OPTION}
                                handleSetRadioValue={(item:string)=>onChange(item,"sezTaxPayment")}
                                radioValue={filtersValue?.sezTaxPayment}
                                alignment="horizontal"
                                backGround={true}
                            />
                        </div>
                    </div>

                    <div className='mt-2 ml-1'>
                        <label className='mb-1'>SEZ</label>
                        <div>
                            <RadioContainer
                                optionsList={SEZ_OPTION}
                                handleSetRadioValue={(item:string)=>onChange(item,"sez")}
                                radioValue={filtersValue?.sez}
                                alignment="horizontal"
                                backGround={true}
                            />
                        </div>
                    </div>


                    <div className='mt-2 ml-1'>
                        <label className='mb-1'>Export</label>
                        <div>
                            <RadioContainer
                                optionsList={EXPORT_OPTION}
                                handleSetRadioValue={(item:string)=>onChange(item,"exports")}
                                radioValue={filtersValue?.exports}
                                alignment="horizontal"
                                backGround={true}
                            />
                        </div>
                    </div>

                </div>

                <div className='d-flex align-items-center justify-content-end pb-3 '>
                    <button className='mr-2 btn btn-outline' onClick={() => {
                        clearFilter()
                        setToggle(!toggle)
                    }
                    }>Clear Filter</button>
                    <button className='btn btn-primary mr-3' onClick={() => {
                        handleSubmit()
                        setToggle(!toggle)
                    }}>Apply</button>
                </div>
            </DropdownMenu>
        </ButtonDropdown>
    )
}

export default OutWardsFilter

